import { Box, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../../components/shared/useUser';
import useNswagClient from '../../../../hooks/api/useNswagClient';
import { RetailerMetrics, UserFranchiseList } from '../../../../app/services/api/ofdClient';

const RetailersHeadline = () => {
  const { franchises } = useContext(UserContext);
  const { getOfdDashboardRetailerMetrics } = useNswagClient();
  const [metrics, setMetrics] = useState<RetailerMetrics | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      setIsLoading(true);
      try {
        // Build user franchises payload with both names and IDs
        const userFranchises: UserFranchiseList = {
          franchiseNames: franchises
            .filter(f => f.franchiseName)
            .map(f => f.franchiseName as string),
          franchiseIds: franchises
            .filter(f => f.franchiseId)
            .map(f => f.franchiseId as number),
          otherRegions: false,
          currentFranchiseName: '',
          taskView: false,
        };

        const response = await getOfdDashboardRetailerMetrics(userFranchises);
        setMetrics(response.metrics ?? null);
      } catch (error) {
        console.error('Error fetching retailer metrics:', error);
        setMetrics(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMetrics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [franchises]);

  if (isLoading) {
    return (
      <Box
        sx={{
          minWidth: '150px', textAlign: 'center', padding: '16px',
        }}>
        <Typography color="text.secondary">Loading...</Typography>
      </Box>
    );
  }

  const completedPercentage = metrics?.completedPercentage ?? 0;
  const completedChange = metrics?.percentageChange ?? 0;
  const isPositive = completedChange >= 0;

  return (
    <Box
      sx={{
        minWidth: '150px', textAlign: 'center', padding: '16px',
      }}>
      <Typography color="text.secondary"
        gutterBottom>
        Onboarding Complete
      </Typography>
      <Typography component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}>
        {completedPercentage.toFixed(1)}%
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}>
          {isPositive ? '+' : ''}{completedChange} new
        </Typography>
      </Box>
      <Typography component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box>
  );
};

export default RetailersHeadline;
